var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"sidebar-links"},[_c('router-link',{attrs:{"to":"/hospitals"}},[_vm._v("All Hospitals")]),_vm._v(" "),_c('rp-permissions',{attrs:{"requireAll":['write_hospitals']}},[_c('router-link',{attrs:{"to":"/hospitals/add-hospital"}},[_vm._v("Add Hospital")])],1)],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a8e047b","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SideNav/HospitalsLinks.vue
// module id = null
// module chunks = 